import { useQuery } from "@apollo/client";

import AdminGoalTemplate from "@components/admin/AdminGoalTemplate";
import HandleQuery from "@components/HandleQuery";
import ExpertJourneyPage from "@components/pageTypes/ExpertJourneyPage";
import { GetGoalTemplateDocument, GetGoalTemplateQuery, GetGoalTemplateQueryVariables } from "@typing/Generated";

type Props = {
  goalTemplateId: string;
  journeyId: string;
};

const ExpertJourneyGoalPreviewPage = ({ goalTemplateId, journeyId }: Props) => {
  const getGoalTemplateQuery = useQuery<GetGoalTemplateQuery, GetGoalTemplateQueryVariables>(GetGoalTemplateDocument, {
    variables: {
      id: goalTemplateId
    }
  });

  return (
    <ExpertJourneyPage helmetKey="pageTitles.expertJourney.goalTemplate.show" journeyId={journeyId}>
      <div className="contentSpacing">
        <HandleQuery query={getGoalTemplateQuery}>
          {data => <AdminGoalTemplate goalTemplate={data.goalTemplate} journeyId={journeyId} />}
        </HandleQuery>
      </div>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyGoalPreviewPage;
